import React from 'react'
import PropTypes from 'prop-types'
import { ArrowForwardIos } from '@material-ui/icons'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { connect } from 'react-redux'
import './TemplateSettings.scss'
import Comps from '@engine/comps'
import { Toggle_Access_List } from '@engine/dependencies/constants'
import {
  SALES_COMPARABLES,
  SH_COMPARABLES
} from '../../../engine/dependencies/constants'

export class TemplateSettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageSectionsPanelOpen: true,
      templateTypePanelOpen: true,
      isExpandAll: false
    }
  }

  handleExpandAll = expand => {
    this.setState({
      pageSectionsPanelOpen: expand,
      templateTypePanelOpen: expand,
      isExpandAll: !expand
    })
  }

  checkExpandAll = () => {
    const isExpandAllState =
      this.state.pageSectionsPanelOpen && this.state.templateTypePanelOpen
    this.setState({ isExpandAll: !isExpandAllState })
  }

  handlePageSectionExpansionChange = () => {
    this.setState(
      { pageSectionsPanelOpen: !this.state.pageSectionsPanelOpen },
      () => this.checkExpandAll()
    )
  }

  handleTemplateTypeExpansionChange = () => {
    this.setState(
      { templateTypePanelOpen: !this.state.templateTypePanelOpen },
      () => this.checkExpandAll()
    )
  }

  handleTemplateSelection = template => {
    const {
      toggeleNotes,
      toggleSourceNotes,
      toggleAmenities
    } = Toggle_Access_List

    const templateType = template.templateName
    const payloadData = { templateType }
    payloadData.hasNotes = toggeleNotes.includes(templateType)
    payloadData.hasSourceNotes = toggleSourceNotes.includes(templateType)
    payloadData.hasAmenities = toggleAmenities.includes(templateType)
    payloadData.hasUnitMix = !['T5', 'T6', 'S2'].includes(templateType)
    this.props.toggleFeature(payloadData)
  }

  handlePageSections = event => {
    const key = event.target.name
    this.props.toggleFeature({ [key]: event.target.checked })
  }

  render() {
    const {
      templates,
      templateName,
      salesTemplates,
      studentHousingTemplates,
      toggleSettings: {
        hasBranding,
        hasDonut,
        hasAmenities,
        hasNotes,
        hasSourceNotes,
        hasUnitMix,
        templateType,
        hasPageTitle
      }
    } = this.props
    const templatesToShow = templateName.includes(SALES_COMPARABLES)
      ? salesTemplates
      : templateName.includes(SH_COMPARABLES)
      ? studentHousingTemplates
      : templates
    const { previewImage } = templatesToShow.find(
      template => template.templateName === templateType
    )
    const { pageSectionsPanelOpen, templateTypePanelOpen } = this.state
    const {
      toggeleNotes,
      toggleSourceNotes,
      toggleUnitMix,
      toggleAmenities,
      toggleDonutChart
    } = Toggle_Access_List

    return (
      <div className="template-settings-container">
        <div data-testid="template-settings" className="template-list-tab">
          <div className="template-list-container">
            <ArrowForwardIos className="arrow-forward" />
            <div className="template-list-title">Template</div>
          </div>
          <div className="template-list-customize">
            <div className="customizeLabel">Customize</div>
            {this.state.isExpandAll && (
              <div
                className="expandLabel"
                onClick={() => this.handleExpandAll(true)}
              >
                Expand All
              </div>
            )}
            {!this.state.isExpandAll && (
              <div
                className="expandLabel"
                data-testid="collapseAll"
                onClick={() => this.handleExpandAll(false)}
              >
                Collapse All
              </div>
            )}
          </div>
          <Accordion
            className={`${
              pageSectionsPanelOpen ? '' : 'expansion-panel-color-picker'
            }`}
            expanded={pageSectionsPanelOpen}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              data-testid="pageSectionsExpansionPanel"
              onClick={this.handlePageSectionExpansionChange}
            >
              <div className="panelTitle">PAGE SECTIONS</div>
            </AccordionSummary>
            <AccordionDetails
              className="expansionPanel"
              data-testid="pageSectionsExpansionPanelDetails"
            >
              <FormGroup>
                <div data-testid="page-sections" className="page-options">
                  <div data-testid="Brand">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="hasBranding"
                          checked={hasBranding}
                          color="primary"
                          onChange={this.handlePageSections}
                        />
                      }
                      label="Brand"
                    />
                  </div>
                  <div data-testid="PageTitle">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="hasPageTitle"
                          checked={hasPageTitle}
                          color="primary"
                          onChange={this.handlePageSections}
                          // disabled={templateType === 'T3'}
                        />
                      }
                      // className={templateType === 'T3' ? 'disabled-amenity' : ''}
                      label="Page Title"
                    />
                  </div>
                  {toggleSourceNotes.includes(templateType) && (
                    <div data-testid="SourceNotes">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="hasSourceNotes"
                            checked={hasSourceNotes}
                            color="primary"
                            onChange={this.handlePageSections}
                          />
                        }
                        label="Source notes"
                      />
                    </div>
                  )}
                  {toggleUnitMix.includes(templateType) && (
                    <div data-testid="UnitMix">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="hasUnitMix"
                            checked={hasUnitMix}
                            color="primary"
                            onChange={this.handlePageSections}
                          />
                        }
                        label="Unit mix"
                      />
                    </div>
                  )}
                  {toggeleNotes.includes(templateType) && (
                    <div data-testid="Notes">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="hasNotes"
                            checked={hasNotes}
                            color="primary"
                            onChange={this.handlePageSections}
                          />
                        }
                        label="Notes"
                      />
                    </div>
                  )}
                  {toggleAmenities.includes(templateType) && (
                    <div data-testid="Amenities">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="hasAmenities"
                            checked={hasAmenities}
                            color="primary"
                            onChange={this.handlePageSections}
                          />
                        }
                        label="Amenities"
                      />
                    </div>
                  )}
                  {toggleDonutChart.includes(templateType) && (
                    <div data-testid="Donut">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="hasDonut"
                            checked={hasDonut}
                            color="primary"
                            onChange={this.handlePageSections}
                          />
                        }
                        label="Donut"
                      />
                    </div>
                  )}
                </div>
              </FormGroup>
            </AccordionDetails>
          </Accordion>
          <Accordion
            className={`${
              templateTypePanelOpen ? '' : 'expansion-panel-color-picker'
            }`}
            expanded={templateTypePanelOpen}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              data-testid="templateTypeExpansionPanel"
              onClick={this.handleTemplateTypeExpansionChange}
            >
              <div className="panelTitle">TEMPLATE TYPE</div>
            </AccordionSummary>
            <AccordionDetails
              className="expansionPanel"
              data-testid="templateTypeExpansionPanelDetails"
            >
              <div
                data-testid="template-type"
                className={
                  templateName.includes('salesComp')
                    ? 'template-options-sales'
                    : 'template-options'
                }
              >
                {templatesToShow.map(template => (
                  <div key={template.id} className="temp">
                    <img
                      data-testid={`template_${template.templateName}`}
                      src={
                        templateType === template.templateName
                          ? template.selectedImage
                          : template.notSelectedImage
                      }
                      onClick={() => this.handleTemplateSelection(template)}
                    />
                    <p
                      className={
                        templateType === template.templateName
                          ? 'temp-id-selected'
                          : 'temp-id'
                      }
                    >
                      {template.templateName}
                    </p>
                  </div>
                ))}
              </div>
              <div className="preview">
                <img
                  src={previewImage}
                  style={{ width: '348px', height: '237px' }}
                />
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    )
  }
}

TemplateSettings.propTypes = {
  templateName: PropTypes.string,
  toggleFeature: PropTypes.func,
  templates: PropTypes.array,
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasDonut: PropTypes.bool,
    hasAmenities: PropTypes.bool,
    hasSourceNotes: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasUnitMix: PropTypes.bool
  }),
  salesTemplates: PropTypes.array,
  studentHousingTemplates: PropTypes.array
}

const mapStateToProps = state => ({
  templateName: Comps.selectors.comps.templateName(state),
  toggleSettings: Comps.selectors.comps.toggleSettings(state),
  templates: Comps.selectors.comps.templates(state),
  salesTemplates: Comps.selectors.comps.salesTemplates(state),
  studentHousingTemplates: Comps.selectors.comps.studentHousingTemplates(state)
})

const mapDispatchToProps = {
  toggleFeature: Comps.actions.toggleFeature
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateSettings)
